import { createFileRoute } from '@tanstack/react-router';
import { CampaignsOverviewPage } from '@web/modules/campaigns/overview/campaigns-overview-page';

export const Route = createFileRoute('/_app/campaigns/')({
  component: CampaignsOverviewPage,
});
